import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Navigation from "./components/Navigation";
import Scan from "./components/Scan";
import FavoritedProducts from "./components/FavoritedProducts";
import Products from "./components/Products";
import AddProduct from "./components/AddProduct";
import Signup from "./components/Signup";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import { AuthProvider } from "./contexts/AuthContext";
import LandingPage from "./components/LandingPage";
import PrivateRoute from "./components/PrivateRoute";
import EditProduct from "./components/EditProduct";

function App() {
  return (
    <div className="App">

      <Router>

        <AuthProvider>

          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route path="/signup" component={Signup} />
            <Route path="/login" component={Login} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Switch>
              <Route>
                <PrivateRoute component={Navigation} />
                <PrivateRoute path="/scan" component={Scan} />
                <PrivateRoute path="/addProduct" component={AddProduct} />
                <PrivateRoute path="/editProduct" component={EditProduct} />
                <PrivateRoute path="/products" component={Products} />
                <PrivateRoute path="/list" component={FavoritedProducts} />
              </Route>
            </Switch>

          </Switch>

        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
